module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "text-center"
  }, [_c('ul', {
    staticClass: "type-tab wwf-radio-bttns"
  }, _vm._l((_vm.productidsdetail), function(productdetail) {
    return _c('li', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product),
        expression: "product"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "radio",
        "name": "product",
        "id": 'id-' + productdetail.productname
      },
      domProps: {
        "value": productdetail,
        "checked": _vm._q(_vm.product, productdetail)
      },
      on: {
        "change": function($event) {
          _vm.product = productdetail
        }
      }
    }), _vm._v("\n          " + _vm._s(productdetail.productname) + "\n          "), _c('span', {
      staticClass: "wwf-radio"
    })])])
  }))]), _vm._v(" "), (_vm.product != null) ? _c('ul', {
    staticClass: "widget-dollar-handles"
  }, [_vm._l((_vm.product.dollarhandles[_vm.product.donationtypes[0]]), function(dollarhandle) {
    return _c('li', [_c('div', {
      staticClass: "inner"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('span', {
      style: ('background-image: url(' + dollarhandle.img + ')')
    })]), _vm._v(" "), _c('div', {
      staticClass: "desc"
    }, [_c('h2', [_vm._v("$" + _vm._s((dollarhandle.amount.indexOf('.00') >= 0) ? dollarhandle.amount.slice(0, -3) : dollarhandle.amount))]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(dollarhandle.text))])]), _vm._v(" "), _c('p', {
      staticClass: "donate-amount",
      on: {
        "click": function($event) {
          _vm.redirect(_vm.product.urlPath, dollarhandle.amount, dollarhandle.amount)
        }
      }
    }, [_vm._v("Donate $" + _vm._s((dollarhandle.amount.indexOf('.00') >= 0) ? dollarhandle.amount.slice(0, -3) : dollarhandle.amount))])])])
  }), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "inner"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "desc"
  }, [_c('div', {
    staticClass: "other-amount",
    class: _vm.customamount ? 'has-other-content' : ''
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customamount),
      expression: "customamount"
    }],
    attrs: {
      "type": "tel"
    },
    domProps: {
      "value": (_vm.customamount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customamount = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._m(1, false, false)]), _vm._v(" "), _c('h5', [_vm._v("choose your own amount")])]), _vm._v(" "), _vm._v("\",customamount)\"\n          class=\"donate-amount\"\n        >Donate $" + _vm._s((_vm.customamount && _vm.customamount.indexOf('.00') >= 0) ? _vm.customamount.slice(0, -3) : _vm.customamount)), _c('p')])])], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "img"
  }, [_c('span', {
    staticClass: "dh-misc-img"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pencil"
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt"
  }), _vm._v(" "), _c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a8754eb0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=bhy68egj1x!./~/string-replace-webpack-plugin/loader.js?id=wgppdwdx8dq!./src/components/product/DonateWidget.vue
// module id = 653
// module chunks = 0